import React, { useMemo } from "react";
import Marquee from "react-fast-marquee";
import ActivityCard from "./ActivityCard";

// Fisher-Yates shuffle algorithm
const shuffleArray = (array) => {
    const newArray = [...array];
    for (let i = newArray.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [newArray[i], newArray[j]] = [newArray[j], newArray[i]];
    }
    return newArray;
};

const MarqueeGrid = ({ activities, showGradient = true }) => {
    // Create randomized versions of all activities for each row
    // useMemo ensures they don't reshuffle on every render
    const row1Items = useMemo(() => shuffleArray(activities), [activities]);
    const row2Items = useMemo(() => shuffleArray(activities), [activities]);
    const row3Items = useMemo(() => shuffleArray(activities), [activities]);

    return (
        <div className="relative w-full py-4 sm:py-6 md:py-8">
            {/* Row 1 - Move Left */}
            <div className="mb-4 sm:mb-5 md:mb-6">
                <Marquee speed={30} gradient={showGradient ? "#F2E2D5" : "transparent"} gradientWidth={40} loop={0}>
                    {row1Items.map((activity, index) => (
                        <ActivityCard
                            key={`row1-${index}`}
                            icon={activity.icon}
                            text={activity.text}
                        />
                    ))}
                </Marquee>
            </div>

            {/* Row 2 - Move Right */}
            <div className="mb-4 sm:mb-5 md:mb-6">
                <Marquee speed={30} gradient={showGradient ? "#F2E2D5" : "transparent"} direction="right" gradientWidth={40} loop={0}>
                    {row2Items.map((activity, index) => (
                        <ActivityCard
                            key={`row2-${index}`}
                            icon={activity.icon}
                            text={activity.text}
                        />
                    ))}
                </Marquee>
            </div>

            {/* Row 3 - Move Left */}
            <div>
                <Marquee speed={30} gradient={showGradient ? "#F2E2D5" : "transparent"} gradientWidth={40} loop={0}>
                    {row3Items.map((activity, index) => (
                        <ActivityCard
                            key={`row3-${index}`}
                            icon={activity.icon}
                            text={activity.text}
                        />
                    ))}
                </Marquee>
            </div>
        </div>
    );
};

export default MarqueeGrid;
